import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import FullComparisonDialog from '@/plans/ZOOM_MEETING/dialog/full-comparison-dialog';
import { trackingPlanTypes } from '@/common/constants';

export default {
  computed: {
    fullComparisonDialogProps() {
      return {}
    }
  },
  methods: {
    async showFullComparisonDialog() {
      this.$tracking.buyInteraction('switch plans selected', trackingPlanTypes.ZONE_PRO_PLUS);
      await this.fullComparisonDialog.confirm(this.fullComparisonDialogProps);
    },
  },
  created() {
    this.fullComparisonDialog = new ServiceConfirm(FullComparisonDialog);
  },
};
